import { useEffect } from 'react';

import loadScript from '@upgrade/ui-utils/utils/load-script';

const useTrustpilot = () => {
  useEffect(() => {
    const trustpilotLoaded = Boolean(window.Trustpilot);
    if (trustpilotLoaded) {
      window.Trustpilot.Modules.WidgetManagement.findAndApplyWidgets();
    } else {
      loadScript('https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js').catch(e => console.error(e));
    }
  }, []);
};

export default useTrustpilot;
